import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { userInfo } from '../store/selectors/user';

interface ProtectedRouteProps {
  children: ReactNode;
  redirectTo?: string;
  requireAuth?: boolean;
}

export const ProtectedRoute = ({ 
  children, 
  redirectTo = '/', 
  requireAuth = true 
}: ProtectedRouteProps) => {
  const user = useSelector(userInfo);
  const location = useLocation();
  
  // Токен — это и есть сессия. `user.isAuth` поднимается только когда
  // подгрузится профиль, а при перезагрузке страницы он на первом рендере
  // ещё false: требовать его здесь значило выкинуть пользователя на главную
  // с любого защищённого адреса, открытого напрямую или обновлённого F5.
  // Если токен протух, запрос вернёт 401, и перехватчик axios разлогинит —
  // тогда редирект случится по делу.
  const hasToken = localStorage.getItem('token');
  const isAuthenticated = user.isAuth || Boolean(hasToken);
  
  // If auth is required but user is not authenticated
  if (requireAuth && !isAuthenticated) {
    // Save the attempted location for potential redirect after auth
    const from = location.pathname + location.search;
    
    return <Navigate 
      to={redirectTo} 
      state={{ from }} 
      replace 
    />;
  }
  
  // If auth is NOT required but user IS authenticated (e.g., login page when already logged in)
  if (!requireAuth && isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }
  
  return <>{children}</>;
};